// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TNewPatch, TPaginatedPatches, TPatch } from '~/misc/patch/types';
import type { TManagerCompanyPatchesPayload } from '~/modules/manager/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerPatchModel extends ManagerResource {
  index(
    companyId: number,
    payload?: TManagerCompanyPatchesPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedPatches> {
    return this.get<TPaginatedPatches>(`companies/${companyId}/patches/`, payload, requestConfig);
  }

  store(
    companyId: number,
    payload?: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPatch> {
    return this.post<TPatch>(`companies/${companyId}/patches/`, payload, requestConfig);
  }

  update(
    patchId: number,
    payload: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPatch> {
    return this.patch<TPatch>(`patches/${patchId}`, payload, requestConfig);
  }

  destroy(patchId: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`patches/${patchId}`, undefined, requestConfig);
  }
}
